import { Eyebrow, Reveal } from "./Reveal";

export const Motto = ({ testid = "motto", className = "" }) => (
  <Reveal className={`py-20 sm:py-28 text-center ${className}`} data-testid={testid}>
    <Eyebrow className="mb-10">In her words</Eyebrow>
    <blockquote className="font-light text-xl sm:text-2xl lg:text-[28px] leading-relaxed text-stone-800 max-w-3xl mx-auto px-2">
      “I’m not the best, but every day I am doing <em className="not-italic font-normal text-[var(--gold)]">my best</em> to be the best version of myself.”
    </blockquote>
    <p className="mt-10 text-xs uppercase tracking-[0.3em] text-stone-600">— Mimi Tao</p>
  </Reveal>
);
